<button
    class="btn btn-{{ variant }} btn-{{ size }} {{ buttonClass }}"
    [disabled]="disabled"
    (click)="handleClick($event)"
>
    <ng-content></ng-content>
</button>
